export default __webpack_public_path__ + "static/media/fontRoboto400_cyrillic_ext.80437895.woff2";